import React from 'react'
import { BounceContainer } from '@components/BounceContainer/BounceContainer'
import { Avatar, ListItem as MUIListItem, ListItemIcon, ListItemText } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { HiChevronRight } from 'react-icons/hi'

interface ListItemProps {
  image?: string
  emoji?: string
  primaryText: string
  secondaryText: string
  route: string
  navState?: any
}

const ListItem: FC<ListItemProps> = ({
  image,
  emoji,
  primaryText,
  secondaryText,
  route,
  navState,
}) => {
  const navigate = useNavigate()

  return (
    <BounceContainer>
      <MUIListItem onClick={() => navigate(route, { state: navState })}>
        <ListItemIcon>
          {image ? (
            <Avatar sx={{ bgcolor: 'background.paper' }} src={image} />
          ) : (
            <Avatar sx={{ bgcolor: 'background.paper' }}>{emoji}</Avatar>
          )}
        </ListItemIcon>
        <ListItemText primary={primaryText} secondary={secondaryText} />
        <ListItemIcon sx={{ justifyContent: 'flex-end' }}>
          <HiChevronRight color="white" size={30} />
        </ListItemIcon>
      </MUIListItem>
    </BounceContainer>
  )
}

export default ListItem
